import { apiHelper } from '../utils/newRequestHelpers';

export default {
  getCustomerJourneyList() {
    return apiHelper.get('v1/customer-journey');
  },
  // updatingMode: stop / pause
  updateCustomerJourney(id, updatingMode) {
    return apiHelper.put(`v1/customer-journey/${id}/${updatingMode}`);
  },
  deleteCustomerJourney(id) {
    return apiHelper.delete(`v1/customer-journey/${id}`);
  },
  cloneCustomerJourney(id) {
    return apiHelper.post(`v1/customer-journey/${id}/clone`);
  }
};
